import {
  Controller,
  ControllerFieldState,
  ControllerRenderProps,
  useFieldArray,
} from 'react-hook-form';
import { ApplicationDataFieldCommonProps } from './types';
import { ApplicationDataBaseField } from './ApplicationDataBaseField';
import { ApplicationDataFormValues } from '../ApplicationDataForm/ApplicationDataFormSchema';
import { Fragment, useState } from 'react';
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  Divider,
  Icon,
  Tooltip,
} from '@blueprintjs/core';
import { ApplicationDataNumberField } from './ApplicationDataNumberField';
import styles from './ApplicationDataChildrenField.module.css';

export const ApplicationDataChildrenField: React.FC<
  ApplicationDataFieldCommonProps
> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const { fields, append, remove } = useFieldArray<ApplicationDataFormValues>({
    name: 'Children',
  });

  return (
    <Controller
      name="Children"
      render={function ({
        field,
        fieldState,
      }: {
        field: ControllerRenderProps<ApplicationDataFormValues, 'Children'>;
        fieldState: ControllerFieldState;
      }): React.ReactElement {
        return (
          <ApplicationDataBaseField
            errorMessage={
              fieldState.invalid ? fieldState.error?.message : undefined
            }
            valueElement={
              <>
                <span>{field.value ? field.value.length : '-'}</span>
                {field.value.length > 0 && (
                  <Tooltip
                    placement={'top'}
                    content={
                      <div>
                        <p>Children:</p>
                        <ul>
                          {field.value.map((child, i) => (
                            <li key={child.ID || i}>
                              <span>
                                {'Age: '}
                                {child.Age}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    }
                    openOnTargetFocus={false}
                  >
                    <Icon icon="info-sign" style={{ marginLeft: '0.25rem' }} />
                  </Tooltip>
                )}
              </>
            }
            inputElement={
              <>
                <Button icon="new-person" onClick={() => setIsOpen(true)} fill>
                  Edit children ({field.value.length ?? 0})
                </Button>
                <Dialog
                  {...props}
                  title="Edit children"
                  isCloseButtonShown
                  isOpen={isOpen}
                  onClose={() => setIsOpen(false)}
                >
                  <DialogBody className={styles.dialogBody}>
                    {fields.map((item, index) => {
                      return (
                        <Fragment key={item.id}>
                          {index !== 0 && (
                            <Divider className={styles.divider} />
                          )}
                          <ApplicationDataNumberField
                            label="Age"
                            name={`Children.${index}.Age`}
                            applicationID={props.applicationID}
                          />
                          <Button
                            intent="danger"
                            icon="trash"
                            onClick={() => remove(index)}
                          >
                            Delete child
                          </Button>
                        </Fragment>
                      );
                    })}
                  </DialogBody>
                  <DialogFooter>
                    <Button
                      intent="primary"
                      onClick={() =>
                        append({
                          ID: null,
                          Age: null,
                        })
                      }
                    >
                      Add child
                    </Button>
                  </DialogFooter>
                </Dialog>
              </>
            }
            {...props}
          />
        );
      }}
    />
  );
};
